var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { UuiFlexlayout, UuiLogo } from '@aonunited/react';
import './header.scss';
import React, { useEffect, useState, useRef } from 'react';
import { getUserInfo } from '../../api/userName';
import { getAboutusInfo } from '../../api/about';
import { Link, useNavigate } from 'react-router-dom';
import { FaUserLarge } from "react-icons/fa6";
import { eApplicationName, getApplicationConfig } from '../../constants/utilities';
import { useLocation } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';
import Aboutus from '../../pages/Dailog/aboutUs/aboutus';
import { useAppInfoStore, useClientPageStore, useErrorStore } from '../../store';
import { getAdvSearchMarketType, getCountries, getRegions, getStates } from '../../api/common';
import { isInternaluser } from '../../api/auth/okta';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faX } from '@fortawesome/free-solid-svg-icons';
import { helpDocGuid } from '../../constants/helpDocGuids';
import { carrierMatrixClients } from '../../constants/carrierMatrixClients';
var env = process.env.NODE_ENV;
var markeAndChangeRequestForm = 'https://one.aon.net/sites/Intranet-MarketSecurity/SitePages/Market-Requests-and-RFPs.aspx';
var AccountSettingUrl = env === "production" ? 'https://aon-ext.okta.com/enduser/settings' : 'https://aon-ext.oktapreview.com/enduser/settings';
var Header = function () {
    var navigate = useNavigate();
    var _a = useState(), applicationName = _a[0], setApplicationName = _a[1];
    var _b = useState(false), showLogOutBox = _b[0], setShowLogoutBox = _b[1];
    var _c = useState("Home"), menuSelected = _c[0], setMenuSelected = _c[1];
    var _d = useState(), userData = _d[0], setUserData = _d[1];
    var location = useLocation();
    var oktaAuth = useOktaAuth().oktaAuth;
    var _e = useState(false), showAboutDialog = _e[0], setShowAboutDialog = _e[1];
    var appConfig = getApplicationConfig();
    var ref = useRef(null);
    var appStoreINfo = useAppInfoStore();
    var errorStore = useErrorStore();
    var clientStore = useClientPageStore();
    //Humberger for Responsive header
    var _f = useState(false), isMobileView = _f[0], setIsMobileView = _f[1];
    var _g = useState(false), isMenuOpen = _g[0], setIsmenuOpen = _g[1];
    useEffect(function () {
        var resize = function () {
            if (window.innerWidth <= 720) {
                setIsMobileView(true);
            }
            else {
                setIsMobileView(false);
            }
        };
        resize();
        window.addEventListener("resize", resize);
        return function () {
            window.removeEventListener("resize", resize);
        };
    }, []);
    var handleMenu = function () {
        setIsmenuOpen(!isMenuOpen);
    };
    useEffect(function () {
        setIsmenuOpen(false);
    }, [menuSelected]);
    //This useEffect is used for get the rendering application and to find the userName and Email
    useEffect(function () {
        var callUserInfo = function () { return __awaiter(void 0, void 0, void 0, function () {
            var userInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getUserInfo()];
                    case 1:
                        userInfo = _a.sent();
                        setUserData({ userName: userInfo.displayName, email: userInfo.email });
                        appStoreINfo.storeUserInfo(userInfo);
                        return [2 /*return*/];
                }
            });
        }); };
        callUserInfo();
        setApplicationName(appConfig.applicationName);
        document.title = appConfig.applicationName;
    }, []);
    // Ensure the element is rendered before focusing
    var appInfo = useAppInfoStore();
    useEffect(function () {
        var onLoad = function () { return __awaiter(void 0, void 0, void 0, function () {
            var regionsResponse, country, sortCountry, states, appConfig, applicationId, advSearchMarketType;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getRegions()];
                    case 1:
                        regionsResponse = _a.sent();
                        appInfo.setRegions(regionsResponse.data);
                        return [4 /*yield*/, getCountries()];
                    case 2:
                        country = _a.sent();
                        sortCountry = country.data.sort(function (a, b) {
                            if (a.description < b.description) {
                                return -1;
                            }
                            else if (a.description > b.description) {
                                return +1;
                            }
                            else
                                return 0;
                        });
                        return [4 /*yield*/, getStates()];
                    case 3:
                        states = _a.sent();
                        appInfo.setStates(states.data);
                        appInfo.setCountry(sortCountry);
                        appConfig = getApplicationConfig();
                        applicationId = appConfig.applicationId;
                        if (appConfig.applicationId === 1 && isInternaluser()) {
                            applicationId = 3;
                        }
                        return [4 /*yield*/, getAdvSearchMarketType(applicationId)];
                    case 4:
                        advSearchMarketType = _a.sent();
                        appInfo.setMarketType(advSearchMarketType.data);
                        return [2 /*return*/];
                }
            });
        }); };
        onLoad();
    }, []);
    useEffect(function () {
        if (location.pathname.includes("Client")) {
            setMenuSelected("Client");
        }
        else if (location.pathname.includes("Market")) {
            setMenuSelected("Market");
        }
        else if (location.pathname.includes("Research")) {
            setMenuSelected("Research");
        }
        else if (location.pathname.includes("Ratings")) {
            setMenuSelected("Ratings");
        }
        else if (location.pathname.includes("Guides")) {
            setMenuSelected("Guides");
        }
        else if (location.pathname.includes("Sources")) {
            setMenuSelected("Sources");
        }
        else if (location.pathname.includes("Home")) {
            setMenuSelected("Home");
        }
        else if (location.pathname.includes("recent")) {
            setMenuSelected("recent_changes");
        }
        else {
            if (appConfig.applicationId === 1) {
                setMenuSelected("Client");
            }
            else {
                setMenuSelected("Home");
            }
        }
        var callAboutUSInfo = function () { return __awaiter(void 0, void 0, void 0, function () {
            var pageInfoRes, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getAboutusInfo()];
                    case 1:
                        pageInfoRes = _a.sent();
                        appStoreINfo.setAppInfo(pageInfoRes.data.IEContactID, pageInfoRes.data.ApiVersion, pageInfoRes.data.Copyright);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.log("Testing Error " + error_1);
                        errorStore.showError({ message: "Error", code: "500" });
                        navigate("/error");
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        callAboutUSInfo();
    }, []);
    //This useEffect is used to trigger logout box events
    useEffect(function () {
        function handleClickedOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setShowLogoutBox(false);
            }
            else if (event.target && event.target.id === "__about__") {
                handleDialogVisibility();
                setShowLogoutBox(false);
            }
            else if (event.target && event.target.id === "__logout__") {
                logout();
            }
        }
        if (showLogOutBox) {
            document.addEventListener('mousedown', handleClickedOutside);
        }
        return function () {
            document.removeEventListener('mousedown', handleClickedOutside);
        };
    }, [showLogOutBox]);
    var showLogOutBoxFun = function () {
        setShowLogoutBox(!showLogOutBox);
    };
    //Sign out
    var logout = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: 
                // oktaAuth.tokenManager.clear();
                return [4 /*yield*/, oktaAuth.signOut()];
                case 1:
                    // oktaAuth.tokenManager.clear();
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var handelNavigation = function () {
        navigate("/");
    };
    var handleDialogVisibility = function () {
        setShowAboutDialog(!showAboutDialog);
    };
    var internalUser = isInternaluser();
    var handleQuickStartGuideDownload = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, clientStore.handlePdfDownload(helpDocGuid.marketReviewUserGuide)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    errorStore.showError({ message: "Error", code: "500" });
                    navigate('/error');
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleCarrierMatrixQuickLink = function (clientGuid, label) { return __awaiter(void 0, void 0, void 0, function () {
        var result, error_3;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, clientStore.selectClient(clientGuid, undefined, label)];
                case 1:
                    result = _b.sent();
                    if (result.success) {
                        setMenuSelected("Client");
                        navigate('/');
                    }
                    else {
                        errorStore.showError({ message: (_a = result.message) !== null && _a !== void 0 ? _a : "Error", code: "401" });
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_3 = _b.sent();
                    errorStore.showError({ message: "Error", code: "500" });
                    navigate('/error');
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "header-cover" },
            React.createElement(UuiFlexlayout, { justify: "space-between", alignItems: "center", style: { height: '60px' } },
                React.createElement(UuiLogo, { className: 'logo-design', onClick: handelNavigation }),
                React.createElement("span", { style: { padding: "5px 30px" } },
                    React.createElement("h6", { className: "title" }, applicationName)),
                React.createElement("div", { style: { fontSize: "1.5rem", padding: "5px 30px", position: "relative" }, onClick: showLogOutBoxFun },
                    React.createElement(FaUserLarge, null),
                    showLogOutBox && React.createElement("div", { ref: ref, tabIndex: 0, className: 'logout-box' },
                        React.createElement("div", { className: 'logout-design-top text-design-right' },
                            React.createElement("div", { className: 'bold-text pdtop10' }, userData === null || userData === void 0 ? void 0 : userData.userName),
                            React.createElement("div", { className: '' }, userData === null || userData === void 0 ? void 0 : userData.email)),
                        React.createElement("hr", null),
                        React.createElement("div", { className: 'logout-design-bottom' },
                            appConfig.applicationId === 2 && React.createElement("a", { id: '__pdf__', onClick: handleQuickStartGuideDownload }, "Quick Start Guide"),
                            appConfig.applicationId !== 3 && !isInternaluser() &&
                                React.createElement("a", { id: '__account_setting_', target: "_blank", href: AccountSettingUrl }, "Account Settings (Password/MFA)"),
                            React.createElement("a", { id: '__about__' }, "About"),
                            React.createElement("a", { id: '__logout__' }, "LogOut"))))),
            React.createElement("div", { className: "header" },
                isMobileView && React.createElement(FontAwesomeIcon, { onClick: handleMenu, icon: faBars }),
                React.createElement("div", { className: "headerLinks ".concat(isMobileView && isMenuOpen ? "headerOpen" : "", " ").concat(!isMenuOpen ? "headerClose" : "") },
                    isMobileView && isMenuOpen && React.createElement(UuiLogo, { className: 'logo-mobile-view', onClick: handelNavigation }),
                    isMobileView && isMenuOpen && React.createElement("div", { className: 'crossIcon' }, React.createElement(FontAwesomeIcon, { style: { paddingInline: "16px", fontSize: "21px" }, onClick: handleMenu, icon: faX })),
                    (applicationName !== eApplicationName.marketPreview || (applicationName === eApplicationName.marketPreview && !internalUser)) && React.createElement(Link, { to: "/", onClick: function () { return setMenuSelected("Home"); }, className: menuSelected === "Home" ? "selected" : "" }, "Home"),
                    applicationName === eApplicationName.marketPreview && internalUser && React.createElement(Link, { to: "/", onClick: function () { return setMenuSelected("Client"); }, className: menuSelected === "Client" ? "selected" : "" }, "Client"),
                    React.createElement(Link, { to: "/Research", onClick: function () { return setMenuSelected("Research"); }, className: menuSelected === "Research" ? "selected" : "" }, "Research"),
                    React.createElement(Link, { to: "/Market", onClick: function () { return setMenuSelected("Market"); }, className: menuSelected === "Market" ? "selected" : "" }, "Market News"),
                    appConfig.applicationId !== 3 ? React.createElement(Link, { to: "/Ratings", onClick: function () { return setMenuSelected("Ratings"); }, className: menuSelected === "Ratings" ? "selected" : "" }, "Ratings Notification Service")
                        : null,
                    appConfig.applicationId === 3 ? React.createElement(Link, { to: "/recent-changes", onClick: function () { return setMenuSelected("recent_changes"); }, className: menuSelected === "recent_changes" ? "selected" : "" }, "Recent Changes")
                        : null,
                    React.createElement(Link, { to: "/Guides", onClick: function () { return setMenuSelected("Guides"); }, className: menuSelected === "Guides" ? "selected" : "" }, "Guides"),
                    React.createElement(Link, { to: "/Sources", onClick: function () { return setMenuSelected("Sources"); }, className: menuSelected === "Sources" ? "selected" : "" }, "Sources And Disclaimers"),
                    appConfig.applicationId === 3 && isInternaluser() && isMobileView &&
                        React.createElement(MarketChageRequestForm, null),
                    appConfig.applicationId === 1 && internalUser && isMobileView &&
                        React.createElement(CarrierMatrixQuickLinks, { onSelect: handleCarrierMatrixQuickLink })),
                appConfig.applicationId === 3 && isInternaluser() && !isMobileView &&
                    React.createElement(MarketChageRequestForm, null),
                appConfig.applicationId === 1 && internalUser && !isMobileView &&
                    React.createElement(CarrierMatrixQuickLinks, { onSelect: handleCarrierMatrixQuickLink }))),
        showAboutDialog && React.createElement(Aboutus, { showDialog: showAboutDialog, onClickClose: handleDialogVisibility })));
};
var MarketChageRequestForm = function () {
    return React.createElement("div", null,
        React.createElement("a", { target: "_blank", href: markeAndChangeRequestForm },
            "New Markets & Changes Request Form",
            React.createElement("svg", { style: { marginLeft: "4px" }, width: "8px", height: "9px", focusable: "false", viewBox: "0 0 7 8", version: "1.1", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
                    React.createElement("g", { transform: "translate(-7.000000, -10.000000)", stroke: "currentColor" },
                        React.createElement("g", { transform: "translate(7.500000, 10.500000)" },
                            React.createElement("line", { x1: "5.5", y1: "0.5", x2: "0", y2: "6.18181818" }),
                            React.createElement("polyline", { points: "6 4.24554252 6 1.16354154e-16 1.98755042 0" })))))));
};
var CarrierMatrixQuickLinks = function (_a) {
    var onSelect = _a.onSelect;
    return React.createElement("div", { className: 'carrierMatrixQuickLinks' }, carrierMatrixClients.filter(function (client) { return !!client.clientGuid; }).map(function (client) { return (React.createElement("a", { key: client.clientGuid, onClick: function () { return onSelect(client.clientGuid, client.label); } }, client.label)); }));
};
export default Header;
